import { Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useField, useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import { useAppDispatch } from "../../app/hooks";
import { useGetListQuery } from "../../features/api/Api";
import { setAddressLocation } from "../../features/customer/customerSlice";
import useLocales from "../../hooks/useLocales";
import { IOption } from "../../interfaces/Utils";
import { isExists, locationTypeEnum, params } from "../../utils";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#0063cc",
    },
    "&:hover fieldset": {
      borderColor: "#0063cc",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
  },
});

interface IReferenceSelect {
  name: string;
  label: string;
  selectId: any;
  defaultValue?: any;
  onBlur?: any;
  prefix?: string;
  reference?: string;
}

const AddressInput: FC<IReferenceSelect> = (props) => {
  const { translate } = useLocales();
  const { name, selectId, defaultValue } = props;
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  const [options, setOptions] = useState<any[]>([]);
  const isRoot = selectId === "null";
  const [locationLabel, setLocationLabel] = useState<string>("");
  const dispatch = useAppDispatch();

  const {
    data: currentData,
    isLoading,
    error,
  } = useGetListQuery<any>(
    {
      // resource: reference,
      resource: "fixity/customer/addressLocation",
      params,
    },
    { skip: isExists(selectId) ? false : true }
  );

  useEffect(() => {
    if (isExists(defaultValue)) {
      setFieldValue(field.name, defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (!isLoading && !error && currentData) {
      let records: IOption[] = [];

      const filteredData = currentData.data.filter((item: any) =>
        isRoot ? !isExists(item.parentId) : item.parentId === selectId
      );

      dispatch(setAddressLocation(filteredData));

      const locationTypeId =
        filteredData?.length > 0 ? filteredData[0].locationTypeId : null;

      for (const [key, value] of Object.entries(locationTypeEnum)) {
        if (value === locationTypeId) {
          setLocationLabel(key);
        }
      }

      filteredData.map((item: any) =>
        records.push({
          value: item.id,
          label: item.name,
        })
      );

      setOptions(records);
    }
  }, [isLoading, error, currentData]);

  if (options.length < 1) {
    return null;
  }

  return (
    <Autocomplete
      value={
        isExists(field.value)
          ? options.find((option) => option.value === field.value.value)
          : ""
      }
      onChange={(event, newValue) =>
        newValue
          ? setFieldValue(field.name, newValue)
          : setFieldValue(field.name, "")
      }
      onBlur={props.onBlur}
      id={field.name}
      options={options}
      renderInput={(params) => (
        <CssTextField
          {...params}
          label={translate(`${props.prefix ?? ""}${locationLabel}`)}
          error={Boolean(meta.error)}
          helperText={
            !isExists(field.value) &&
            translate(`${props.prefix ?? ""}valid.select_${locationLabel}`)
          }
        />
      )}
    />
  );
};

export default AddressInput;
